// src/sections/WhyChooseUs/WhyChooseUs.tsx
import React from "react";
import choose_1 from "../../../assets/img/choose-1.jpg";
interface WhyChooseUsProps {
  id: string;
}

const WhyChooseUs: React.FC<WhyChooseUsProps> = ({ id }) => {
  return (
    <section id={id} className="py-5 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div>
              <img src={choose_1} alt="image" />
            </div>
          </div>

          <div className="order-1 lg:order-2 space-y-8">
            <div className="space-y-4">
              <h6 className="text-yellow-400 font-semibold text-lg">
                Why Choose Us?
              </h6>
              <h2 className="text-2xl font-bold text-gray-900">
                Meticulous Approach Leading to Efficient Decisive Results
              </h2>
            </div>

            <div className="space-y-6">
              <p className="text-gray-600 leading-relaxed">
                Our ingenuity makes us natural problem-solvers. We are the
                pacesetters for our clients whether through technological
                advancement or innovative business solutions.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Analytical decision making for strongest impact in designing,
                strategizing or developing while working collaboratively on all
                aspects of a project.
              </p>
              <p className="text-gray-600 leading-relaxed">
                The dependable dedicated team for your integrated robust
                business growth.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {[
                "Solving IT Problems",
                "Practice IT Management",
                "Managed IT Service",
                "Digital Marketing",
                "Cloud Services",
              ].map((feature, index) => (
                <div
                  key={index}
                  className="group relative px-4 py-3 pl-6 border-2 border-gray-300 rounded-lg cursor-pointer overflow-hidden transition-all duration-500"
                >
                  {/* Animated background fill */}
                  <div className="absolute inset-0 bg-purple-500 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out z-0"></div>

                  {/* Always-visible left border using pseudo-background */}
                  <div className="absolute top-0 left-0 h-full w-[4px] bg-[#7b68ee] z-10"></div>

                  {/* Optional border change on hover */}
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-purple-500 rounded-lg transition-colors duration-300 z-0"></div>

                  {/* Foreground content */}
                  <div className="relative flex items-center gap-3 z-20">
                    <span className="text-gray-700 font-semibold group-hover:text-white transition-colors duration-300">
                      {feature}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
